import { ExecutionStatus, StageResult } from "../playGroundTypes";
import StageDetail from "./StageDetail";
import StatusBadge from "./StatusBadge";

interface StageResultItemProps {
  result: StageResult;
  isExpanded: boolean;
  onToggleExpand: (stageId: string) => void;
}

const StageResultItem = ({
  result,
  isExpanded,
  onToggleExpand,
}: StageResultItemProps) => {
  const hasDetail =
    result.detail &&
    (result.status === ExecutionStatus.STOPPED ||
      result.status === ExecutionStatus.FAILED);

  const isClickable = !!hasDetail;

  return (
    <div className="border-b border-gray-100 last:border-b-0">
      <div
        className={`flex items-center justify-between px-4 py-3 ${
          isClickable ? "cursor-pointer hover:bg-gray-50" : ""
        }`}
        onClick={() => isClickable && onToggleExpand(result.stageId)}
      >
        <div className="flex items-center gap-2">
          <span className="text-sm font-bold text-gray-800">
            {result.stageName}
          </span>
        </div>
        <StatusBadge status={result.status} />
      </div>

      {isClickable && (
        <div
          className={`overflow-hidden transition-all duration-300 ease-in-out ${
            isExpanded ? "max-h-40 opacity-100" : "max-h-0 opacity-0"
          }`}
        >
          <div className="px-4 pb-3">
            <StageDetail detail={result.detail!} />
          </div>
        </div>
      )}
    </div>
  );
};

export default StageResultItem;
